import { useModal } from "@ebay/nice-modal-react";
import Confirmation from "../views/home/controls/Confirmation";
import useNotifications from "../../core/Notifications";

export const withConfirmationWrapper = (Component) => (props) => {
    const confirmation = useModal(Confirmation);
    const notifications = useNotifications();

    return <Component {...props} confirmation={confirmation} notifications={notifications} />
};
